export default __webpack_public_path__ + "static/media/map.f3e85eb5.png";